import React from "react";
import { LabelData } from "./label_Interface";
import { Box, Chip } from "@mui/material";

interface LabelsProps {
  labels: LabelData[];
}

const Labels: React.FC<LabelsProps> = ({ labels }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      rowGap={1}
      // sx={{ marginBottom: "1em" }}
    >
      {labels.map((tag) => (
        <Chip
          key={`label-${tag.id}`}
          sx={{
            "& .MuiChip-label": {
              px: 1,
              py: 1,
            },
            fontSize: 13,
            height: 21,
            fontWeight: 500,
            borderRadius: 1,
            backgroundColor: "transparent",
            borderColor: tag.css,
            borderWidth: 2,
            borderStyle: "solid",
            color: tag.css,
            marginRight: "0.8em",
          }}
          label={tag.name}
        />
      ))}
    </Box>
  );
};

export default Labels;
